import { render } from "./walletIndex.vue?vue&type=template&id=5de5e8e5"
import script from "./walletIndex.vue?vue&type=script&lang=js"
export * from "./walletIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__